import { render, staticRenderFns } from "./compareScenario.vue?vue&type=template&id=1b24bba6"
import script from "./compareScenario.vue?vue&type=script&lang=js"
export * from "./compareScenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b24bba6')) {
      api.createRecord('1b24bba6', component.options)
    } else {
      api.reload('1b24bba6', component.options)
    }
    module.hot.accept("./compareScenario.vue?vue&type=template&id=1b24bba6", function () {
      api.rerender('1b24bba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/compare/compareScenario.vue"
export default component.exports